import script from "./NodeLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./NodeLayout.vue?vue&type=script&lang=ts&setup=true"

import "./NodeLayout.vue?vue&type=style&index=0&id=60f0e4d9&scoped=true&lang=css"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60f0e4d9"]])

export default __exports__